import FieldSet from '../../FieldSet';

import { Kind } from './Kind';
import { KindColorIcon } from './KindColorIcon';
import { KindIcon } from './KindIcon';
import { KindPillIcon } from './KindPillIcon';

export class KindFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [KindIcon, KindColorIcon, KindPillIcon, Kind];
  }

  get title() {
    return 'Type';
  }
}
